var map = {
	"./id恭喜.png": 323319,
	"./id抱歉.png": 315086,
	"./tp恭喜.png": 61700,
	"./tp抱歉.png": 950045,
	"./vi恭喜.png": 151963,
	"./vi抱歉.png": 583618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824146;